module.exports = __webpack_public_path__ + "61220b9bd0d6a9481b3d6502eec278ce.png";